import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, sample } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media(min-width: 992px) {
    flex-direction: row;
  }
  .GallerySection_list {
    li {
      margin: 1px 1px 1px 0;
      @media(min-width: 992px) {
        margin: 0;
      }
      &:nth-child(even) {
        margin: 1px 0 0 0;
        @media(min-width: 992px) {
          margin: 0;
        }
      }
    }
  }
  .GallerySection_listItem {
    width: calc(50% - 1px);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 155px;
    @media(min-width: 576px) {
      height: 190px;
    }
    @media(min-width: 992px) {
      height: 570px;
      margin: 0;
    }
  }
  .GallerySection_listItemLink {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(circle, rgba(0,0,0,.2) 0%, rgba(0,0,0,.5) 100%);
    font-weight: 800;
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 1.95px;
    text-align: center;
    text-transform: uppercase;
    transition: all .3s ease-out;
    padding: 25px;
    @media(min-width: 992px) {
      font-size: 17px;
      letter-spacing: 2.55px;
    }
    &:hover {
      background: radial-gradient(circle, rgba(0,0,0,.5) 0%, rgba(0,0,0,.7) 100%);
      font-size: 15px;
      @media(min-width: 992px) {
        font-size: 19px;
      }
    }
  }
  .GallerySection_listItemLinkLast {
    font-size: 15px;
    @media(min-width: 992px) {
      font-size: 20px;
    }
  }
  .GallerySection_gallery {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 396px;

    @media(min-width: 992px) {
      height: auto;
    }
    .GallerySection_galleryName {
      font-weight: 800;
      font-size: 19px;
      color: #FFFFFF;
      letter-spacing: 2.85px;
      text-align: center;
      line-height: 26px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .3s ease-out;
      width: 100%;
      height: 100%;
      @media(min-width: 992px) {
        font-size: 23px;
        letter-spacing: 3.45px;
        text-align: left;
      }
      &:hover {
        background: radial-gradient(circle, rgba(0,0,0,.5) 0%, rgba(0,0,0,.7) 100%);
        font-size: 21px;
        @media(min-width: 992px) {
          font-size: 25px;
        }
      }
      p:first-of-type {
        padding: 0 0 25px;
        position: relative;
        margin: 0;
        @media(min-width: 992px) {
          padding: 0 0 35px;
        }
        &::after, &::before {
          content: '';
          width: 50%;
          height: 1px;
          background-color: #FFFFFF;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          @media(min-width: 992px) {
            left: 0;
            transform: none;
          }
        }
        &::after {
          bottom: 0;
        }
        &::before {
          bottom: 8px;
        }
      }
    }
  }
`;

function GallerySection({ content, page }) {
  let allImages;
  if (get(page, 'galleries')) {
    allImages = get(page, 'galleries').map(gallery => get(gallery, 'photos')).flatten().filter(item => get(item, 'contentUrl'));
  }
  return (
    <div className={styles}>
      <Link style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, 'image.contentUrl'), { width: 1000, height: 1000, preserve: true })})` }} name="image-gallery" className="col-lg-4 GallerySection_gallery px-0">
        <span className="GallerySection_galleryName" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'title'))} />
      </Link>
      <ul className="list-unstyled d-flex flex-wrap col-lg-8 px-0 m-0 GallerySection_list">
        {
          get(page, 'galleries').slice(0, 3).map(item => (
            <li key={item._id} className="GallerySection_listItem" style={{ backgroundImage: `url(${buildThumbnailUrl((get(item, 'photos[0]') ? sample(get(item, 'photos')).contentUrl : sample(allImages).contentUrl), { width: 800, height: 800, preserve: true })})` }}>
              <Link name="image-gallery" className="GallerySection_listItemLink" params={{ category: get(item, 'name') }}>
                {get(item, 'name').length === 3 ? get(item, 'name') : ''}
              </Link>
            </li>
          ))
        }
        {
          allImages &&
          <li className="GallerySection_listItem" style={{ backgroundImage: `url(${buildThumbnailUrl((sample(allImages).contentUrl), { width: 800, height: 800, preserve: true })})` }}>
            <Link name="image-gallery" className="GallerySection_listItemLink GallerySection_listItemLinkLast">
              {get(page, 'galleries').length >= 3 ? `+${get(page, 'galleries').length - 3}` : 'View More' }
            </Link>
          </li>
        }
      </ul>
    </div>
  );
}

GallerySection.propTypes = {
  content: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'image_gallery',
})(GallerySection);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/GallerySection.js